import {
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Textarea,
    useToast,
    Box,
    IconButton,
    Switch,
    Select
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import React, { useState, useRef } from "react";
import {almostWhole} from "chart.js/helpers";
import {fileUpload} from "../../../Services/FileService";

function AddBellModal({ isOpen, onClose, handleBellSubmit }) {
    const toast = useToast();
    const audioRef = useRef(null);
    const [bellDetails, setBellDetails] = useState({
        name: "",
        type: "",
        musicFile: "",
        url: "",
        enabled: true,
        description: ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setBellDetails((prev) => ({ ...prev, [name]: value }));
    };

    const handleMusicUpload = async (e) => {
        console.log("handleMusicUpload")
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            const response = await fileUpload(file);
            console.log("response: " + response)

            if(response){
                setBellDetails((prev) => ({...prev, url: response}));
            }
        }
    };

    const handleSubmit = () => {
        try {
            handleBellSubmit(bellDetails);
        } catch (error) {
            console.error(error);
            toast({
                title: "Error!",
                description: "Failed to save bell details. Please try again.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xl">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Add New Bell</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Stack spacing={4}>
                        <FormControl>
                            <FormLabel>Bell Name</FormLabel>
                            <Input
                                name="name"
                                value={bellDetails.name}
                                onChange={handleInputChange}
                                placeholder="Enter Bell Name"
                            />
                        </FormControl>

                        <FormControl>
                            <FormLabel>Bell Type</FormLabel>
                            <Select name="type" value={bellDetails.type} onChange={handleInputChange}>
                                <option value="alarm">Alarm</option>
                                <option value="notification">Notification</option>
                                <option value="reminder">Reminder</option>
                            </Select>
                        </FormControl>

                        {/* Music Upload Section */}
                        <FormControl>
                            <FormLabel>Music File</FormLabel>
                            <Box display="flex" alignItems="center">
                                <label htmlFor="music-upload">
                                    <IconButton
                                        as="span"
                                        icon={<AddIcon />}
                                        colorScheme="blue"
                                        isRound
                                        aria-label="Add Music"
                                    />
                                </label>
                                <input
                                    id="music-upload"
                                    type="file"
                                    accept="audio/*"
                                    style={{ display: "none" }}
                                    onChange={handleMusicUpload}
                                />
                                {bellDetails.musicFile && (
                                    <Box ml={4} display="flex" alignItems="center">
                                        <audio ref={audioRef} src={bellDetails.musicFile} controls />
                                    </Box>
                                )}
                            </Box>
                        </FormControl>

                        <FormControl>
                            <FormLabel>Description</FormLabel>
                            <Textarea
                                name="description"
                                value={bellDetails.description}
                                onChange={handleInputChange}
                                placeholder="Enter Description"
                            />
                        </FormControl>

                        <FormControl display="flex" alignItems="center">
                            <FormLabel>Enable</FormLabel>
                            <Switch
                                isChecked={bellDetails.enabled}
                                onChange={(e) => setBellDetails((prev) => ({ ...prev, enabled: e.target.checked }))}
                            />
                        </FormControl>
                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button colorScheme="green" mr={3} onClick={handleSubmit} disabled={!bellDetails?.url}>
                        Save Bell
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default AddBellModal;